module.exports = __webpack_public_path__ + "img/imprimbook-logo.b6fba60a.png";